/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio Management API
 * REST API for portfolio management service.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: info@etractive.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TieringStats
 */
export interface TieringStats {
    /**
     * 
     * @type {string}
     * @memberof TieringStats
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TieringStats
     */
    typeKey: string;
    /**
     * 
     * @type {string}
     * @memberof TieringStats
     */
    categoryKey: string;
    /**
     * 
     * @type {number}
     * @memberof TieringStats
     */
    count?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TieringStats
     */
    countPercent?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TieringStats
     */
    gnwp?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TieringStats
     */
    gnwpPercent?: number | null;
}

/**
 * Check if a given object implements the TieringStats interface.
 */
export function instanceOfTieringStats(value: object): value is TieringStats {
    if (!('typeKey' in value) || value['typeKey'] === undefined) return false;
    if (!('categoryKey' in value) || value['categoryKey'] === undefined) return false;
    return true;
}

export function TieringStatsFromJSON(json: any): TieringStats {
    return TieringStatsFromJSONTyped(json, false);
}

export function TieringStatsFromJSONTyped(json: any, ignoreDiscriminator: boolean): TieringStats {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'typeKey': json['typeKey'],
        'categoryKey': json['categoryKey'],
        'count': json['count'] == null ? undefined : json['count'],
        'countPercent': json['countPercent'] == null ? undefined : json['countPercent'],
        'gnwp': json['gnwp'] == null ? undefined : json['gnwp'],
        'gnwpPercent': json['gnwpPercent'] == null ? undefined : json['gnwpPercent'],
    };
}

export function TieringStatsToJSON(json: any): TieringStats {
    return TieringStatsToJSONTyped(json, false);
}

export function TieringStatsToJSONTyped(value?: TieringStats | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'typeKey': value['typeKey'],
        'categoryKey': value['categoryKey'],
        'count': value['count'],
        'countPercent': value['countPercent'],
        'gnwp': value['gnwp'],
        'gnwpPercent': value['gnwpPercent'],
    };
}

